import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="23vck4tdvjcc5">
      <Hero data-id="element-1" data-mp="23utbk3a460as" />
      <main data-id="element-2" data-mp="23v2td3l0915e">
        <ProblemSection data-id="element-3" data-mp="23ti864kkyuk7" />
        <SolutionSection data-id="element-4" data-mp="3ik7jmqgv0tve" />
        <VolumesSection data-id="element-5" data-mp="3iiwg8rrbto4t" />
        <BonusesSection data-id="element-6" data-mp="3ijpd910hgz9r" />
        <HowItWorksSection data-id="element-7" data-mp="3mlj9mx3nbh44" />
        <OfferSection data-id="element-8" data-mp="3mkrdnl64zhdb" />
        <GuaranteeSection data-id="element-9" data-mp="3mk84asujy1aw" />
        <TestimonialsSection data-id="element-10" data-mp="3mjg7xft4rzjk" />
        <FaqSection data-id="element-11" data-mp="3rcj846sey78q" />
        <FinalCtaSection data-id="element-12" data-mp="3rdaqgfx028h2" />
      </main>
      <Footer data-id="element-13" data-mp="3recerm310rgq" />
      <StickyCta data-id="element-14" data-mp="3relvsk63foaa" />
    </div>;
}